module.exports = __webpack_public_path__ + "static/banner-ccb338446067b67d62e67be6d58cd760.jpg";